/**
 * Independence Day festive login theme — date gated.
 * Theme UI only on these dates; all other days use the normal/simple login UI.
 *
 * month is 0-based (7 = August)
 */
export const INDEPENDENCE_THEME_START = { month: 7, day: 10 }; // 10 Aug
export const INDEPENDENCE_THEME_END = { month: 7, day: 15 }; // 15 Aug

export const isIndependenceDayThemeActive = (date = new Date()) => {
  const month = date.getMonth();
  const day = date.getDate();

  if (month !== INDEPENDENCE_THEME_START.month) return false;

  return (
    day >= INDEPENDENCE_THEME_START.day && day <= INDEPENDENCE_THEME_END.day
  );
};
